const initialState = {
  promoteurs: [],
  loading: false,
  error: null,
  length: null,
  secteurs: [],
};

const promoteursReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PROMOTEURS_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "GET_PROMOTEURS_SUCCESS":
      return {
        ...state,
        promoteurs: action.payload,
        loading: false,
        length: action.payload.meta.pagination.total,
      };
    case "GET_SECTEURS_SUCCESS":
      return {
        ...state,
        secteurs: action.payload,
      };
    default:
      return state;
  }
};
export default promoteursReducer;
